import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-critical-mass',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './critical-mass.component.html',
  styleUrl: './critical-mass.component.scss',
})
export class CriticalMassComponent {
  // CRITICAL MASS
  progressCriticalMass = Array(20).fill(Math.random());
  @Input() criticalMass = 0;

  // Exponer Math para usar en el html
  Math = Math;
}
